import EventBus from "@plugins/common/service/eventbus";
export const SpeechEvaluationEventBus = new EventBus();
